"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIntlContext = createIntlContext;
function createIntlContext(translations, locale) {
    const formatMessage = (message, values) => {
        if (!(locale in translations)) {
            console.error("locale not found", locale);
            return message.defaultMessage;
        }
        if (!(message.id in translations[locale])) {
            console.error("message not found", message.id);
            return message.defaultMessage;
        }
        let s = translations[locale][message.id];
        if (values !== undefined) {
            for (const [k, v] of Object.entries(values)) {
                s = s.replace(`{${k}}`, `${v}`);
            }
        }
        return s;
    };
    const formatMessageMap = (messages, key, values) => {
        if (key in messages) {
            return formatMessage(messages[key], values);
        }
        console.error("message map item not found", { messages, key });
        return key;
    };
    const formatDate = (date, options) => {
        const dateFormat = new Intl.DateTimeFormat(locale, options);
        return dateFormat.format(date instanceof Date ? date : new Date(date));
    };
    const formatNumber = (value, options) => {
        return new Intl.NumberFormat(locale, options).format(value);
    };
    return {
        locale,
        formatMessage,
        formatMessageMap,
        formatDate,
        formatNumber
    };
}
